import styled from 'styled-components'
import { Box } from 'vvs-uikit'

const DashboardBox = styled(Box)`
  width: 100%;
  border: 3px black solid;
  background: white;
  border-radius: 12px;
  padding: 0.75rem 0.75rem 1.25rem 0.75rem;
`

export default DashboardBox
